import { graphConfig } from "../authConfig";
import { IPublicClientApplication } from "@azure/msal-browser";
import { BaseService } from "./BaseService";

export interface NavUrl {
  key: string;
  url: string;
}

export class NavService extends BaseService {
  public getNavUrls = async (instance: IPublicClientApplication) => {

    const headers = await this.getAuthorizedRequestHeaders(instance);
    const options = {
      method: "GET",
      headers: headers,
    };

      try {
        const response = await fetch(`${graphConfig.navUrlsEndpoint}`, options);
        const responseData = await response.json();
        return responseData as NavUrl[];
      } catch (error) {
        console.log(error);
        return [];
      }
  };
}
